import { Fragment, ReactNode } from 'react';
import { Typography } from '@rossum/ui/material';
import { splitLines } from './computeDiffRows';
import { LineCell } from './LineCell';
import { ViewerFrame } from './ViewerFrame';

type SnapshotViewerProps = {
  text: string;
  label: ReactNode;
};

// Single-pane counterpart of SideBySideDiff for versions with nothing to
// diff against.
export const SnapshotViewer = ({ text, label }: SnapshotViewerProps) => (
  <ViewerFrame
    header={
      <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
        {label}
      </Typography>
    }
    gridTemplateColumns="auto minmax(0, 1fr)"
  >
    {splitLines(text)
      .map((line, index) => ({
        lineNumber: index + 1,
        segments: [{ text: line, highlighted: false }],
      }))
      .map(cell => (
        <Fragment key={cell.lineNumber}>
          <LineCell cell={cell} emphasis={null} />
        </Fragment>
      ))}
  </ViewerFrame>
);
